import React from 'react';
import { connect } from 'react-redux';
import { HeroContainer } from './home-hero';
import { AreasContainer } from './home-areas';
import { AboutContainer } from './home-about';
import { ContactContainer } from './home-contact';
import { TestimonialsContainer } from './home-testimonials';
import AOS from 'aos';
import css from '../styles/home.css';

let { Component } = React;

class Home extends Component {
  componentDidMount() {
    AOS.refreshHard();
  }

  render() {
    return (
      <div>
        <HeroContainer />
        <AreasContainer />
        <AboutContainer />
        <TestimonialsContainer />
        <ContactContainer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    items: state.nav.items
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const HomeContainer = connect(mapStateToProps, mapDispatchToProps)(Home);

export {Home, HomeContainer};



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home.js